import { GLOSSARY } from "../../lib/glossary";

interface AbbreviationTooltipProps {
  term: string;
  className?: string;
}

export default function AbbreviationTooltip({ term, className = "" }: AbbreviationTooltipProps) {
  const definition = GLOSSARY[term];

  if (!definition) {
    return <span className={className}>{term}</span>;
  }

  return (
    <span className={`relative inline-block group ${className}`}>
      <span className="border-b border-dotted border-current cursor-help">
        {term}
      </span>
      <span className="invisible absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2 opacity-0 transition-opacity duration-200 group-hover:visible group-hover:opacity-100 pointer-events-none">
        <span className="relative block">
          <span className="block w-56 rounded-lg bg-gray-900 px-3 py-2 text-xs font-medium text-white shadow-lg dark:bg-gray-700 text-center leading-relaxed">
            {definition}
          </span>
          <span className="absolute -bottom-1 left-1/2 h-2.5 w-2.5 -translate-x-1/2 rotate-45 bg-gray-900 dark:bg-gray-700"></span>
        </span>
      </span>
    </span>
  );
}
